module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('pageTitle', {
    attrs: {
      "title": "我要点评",
      "showRight": true,
      "rightTitle": "发布"
    },
    on: {
      "rightHandler": _vm.publish
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hotelMsg whiteBg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/search/noImg.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.comment.HotelName))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('mu-icon', {
    attrs: {
      "value": "room",
      "color": "#A5A5A5",
      "size": 13
    }
  }), _vm._v("\n\t\t\t\t" + _vm._s(_vm.comment.Address) + "\n\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("入住：" + _vm._s(_vm.comment.CheckInTime))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("离店：" + _vm._s(_vm.comment.CheckOutTime))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("房型：" + _vm._s(_vm.comment.RoomType))])])]), _vm._v(" "), _c('div', {
    staticClass: "greyBg greyBlock"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请您评价本次入住，点评、追评字数大于15字将获取30K币")]), _vm._v(" "), _c('div', {
    staticClass: "feel"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.scoreDisplay) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_c('stars', {
    attrs: {
      "score": _vm.score,
      "canChoose": true
    },
    on: {
      "select": _vm.changeScore
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tagGroup"
  }, _vm._l((_vm.labelList[_vm.score - 1]), function(label) {
    return _c('span', {
      staticClass: "tag",
      class: {
        'active': label.Selected
      },
      on: {
        "click": function($event) {
          return _vm.changeLabel(label)
        }
      }
    }, [_vm._v(_vm._s(label.LabelName))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('inputArea', {
    attrs: {
      "height": "2.15rem",
      "hitMsg": "分享您对酒店环境、服务、设施和价格等的感受"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7397f8bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/comments/writeComments.vue
// module id = 1543
// module chunks = 18